export default __webpack_public_path__ + "static/media/facebook.3905d14a.svg";